export const FACES_PERSONNALISATION = [
  ['AVANT', 'Avant'], ['ARRIERE', 'Dos'], ['COTE_GAUCHE', 'Gauche'],
  ['COTE_DROIT', 'Droite'], ['AUTRE', 'Autre']
];

export const uuidPersonnalisation = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    return (c === 'x' ? r : (r & 3) | 8).toString(16);
  });
};

export const euroPersonnalisation = (value) => Number(value || 0).toLocaleString('fr-FR', { style:'currency', currency:'EUR' });

export function calculerZoneImageUtile(conteneurLargeur, conteneurHauteur, imageLargeur, imageHauteur) {
  const cw = Math.max(0, Number(conteneurLargeur || 0));
  const ch = Math.max(0, Number(conteneurHauteur || 0));
  const iw = Math.max(0, Number(imageLargeur || 0));
  const ih = Math.max(0, Number(imageHauteur || 0));
  if (!cw || !ch || !iw || !ih) return { left:0, top:0, width:100, height:100 };
  const facteur = Math.min(cw / iw, ch / ih);
  const largeur = iw * facteur, hauteur = ih * facteur;
  return { left:(cw-largeur)/(2*cw)*100, top:(ch-hauteur)/(2*ch)*100, width:largeur/cw*100, height:hauteur/ch*100 };
}

// Le canevas conserve un ratio largeur/hauteur de 0,78. Une unité cqw suit sa
// largeur réelle : la typographie reste proportionnelle au visuel à l'écran.
export function tailleTexteCalque(marquage, texte = '') {
  const hauteur = Math.max(3, Number(marquage?.hauteur || 0));
  const largeur = Math.max(3, Number(marquage?.largeur || 0));
  const caracteres = Math.max(1, Array.from(String(texte || '')).length);
  const selonHauteur = hauteur * 0.87;
  const selonLargeur = largeur / (caracteres * 0.62);
  return `${Math.max(0.4, Math.min(selonHauteur, selonLargeur))}cqw`;
}

export function redimensionnerCalque(marquage, deltaLargeur, deltaHauteur) {
  const largeur = Number(marquage.largeur);
  const hauteur = Number(marquage.hauteur);
  const sx = (largeur + deltaLargeur) / largeur;
  const sy = (hauteur + deltaHauteur) / hauteur;
  const souhaite = Math.abs(sx - 1) >= Math.abs(sy - 1) ? sx : sy;
  const minimum = Math.max(3 / largeur, 3 / hauteur);
  const maximum = Math.min((100 - Number(marquage.position_x)) / largeur, (100 - Number(marquage.position_y)) / hauteur);
  const facteur = Math.max(minimum, Math.min(maximum, souhaite));
  return { largeur:largeur * facteur, hauteur:hauteur * facteur };
}

export const RATIO_CANEVAS_PERSONNALISATION = 0.78;

export function adapterCalqueAuRatioImage(marquage, naturalWidth, naturalHeight, ratioCanevas = RATIO_CANEVAS_PERSONNALISATION) {
  const ratioImage = Number(naturalWidth) / Number(naturalHeight);
  if (!Number.isFinite(ratioImage) || ratioImage <= 0) return { ...marquage };
  const largeurInitiale = Math.max(3, Number(marquage.largeur || 30));
  const hauteurInitiale = Math.max(3, Number(marquage.hauteur || 12));
  const ratioPourcent = ratioImage / ratioCanevas;
  const aire = largeurInitiale * hauteurInitiale;
  let largeur = Math.sqrt(aire * ratioPourcent);
  let hauteur = largeur / ratioPourcent;
  const centreX = Number(marquage.position_x || 0) + largeurInitiale / 2;
  const centreY = Number(marquage.position_y || 0) + hauteurInitiale / 2;
  const facteurLimite = Math.min(1, (2 * Math.min(centreX, 100 - centreX)) / largeur, (2 * Math.min(centreY, 100 - centreY)) / hauteur);
  largeur *= Math.max(0, facteurLimite);
  hauteur *= Math.max(0, facteurLimite);
  return {
    ...marquage,
    position_x:Math.max(0, Math.min(100 - largeur, centreX - largeur / 2)),
    position_y:Math.max(0, Math.min(100 - hauteur, centreY - hauteur / 2)),
    largeur,
    hauteur
  };
}

export function tarifPersonnalisation(options, groupes, optionIds, quantite = 1) {
  const ids = new Set(optionIds || []);
  const groupesFactures = new Set();
  let unite = 0;
  (options || []).filter((o) => o.actif !== false && ids.has(o.id) && o.mode_tarification === 'PAYANTE').forEach((o) => {
    if (o.groupe_tarifaire_id) groupesFactures.add(o.groupe_tarifaire_id);
    else unite += Number(o.prix_individuel_ttc || 0);
  });
  groupesFactures.forEach((id) => { unite += Number((groupes || []).find((g) => g.id === id && g.actif !== false)?.prix_ttc || 0); });
  return Math.round(unite * Math.max(1, Number(quantite || 1)) * 100) / 100;
}

export function marquagesProduitCatalogue(produitId, personnalisation = {}) {
  const visuels = (personnalisation.visuels || []).filter((visuel) => visuel.produit_id === produitId && visuel.actif !== false);
  const visuelIds = new Set(visuels.map((visuel) => visuel.id));
  const dejaVus = new Set();
  const club = (personnalisation.marquages || [])
    .filter((marquage) => visuelIds.has(marquage.visuel_id) && marquage.visible !== false && !marquage.option_id
      && ['IMAGE_FIXE', 'TEXTE_FIXE'].includes(marquage.type))
    .map((marquage) => ({
      id:marquage.id,
      libelle:String(marquage.libelle || marquage.texte_fixe || (marquage.type === 'IMAGE_FIXE' ? 'Image Club' : 'Texte Club')).trim(),
      tarif:'INCLUSE',
    }))
    .filter((marquage) => {
      const cle=marquage.libelle.toLocaleLowerCase('fr');
      if (dejaVus.has(cle)) return false;
      dejaVus.add(cle);
      return true;
    });
  const groupes = new Map((personnalisation.groupes_tarifaires || [])
    .filter((groupe) => groupe.actif !== false)
    .map((groupe) => [groupe.id, groupe]));
  const adherent = (personnalisation.options || [])
    .filter((option) => option.produit_id === produitId && option.actif !== false)
    .map((option) => {
      const groupe = option.groupe_tarifaire_id ? groupes.get(option.groupe_tarifaire_id) : null;
      const prix = option.mode_tarification === 'PAYANTE'
        ? Number(groupe ? groupe.prix_ttc : option.prix_individuel_ttc)
        : 0;
      return {
        id:option.id,
        libelle:String(option.libelle || 'Personnalisation').trim(),
        obligatoire:!!option.obligatoire,
        tarif:option.mode_tarification !== 'PAYANTE' ? 'INCLUSE' : Number.isFinite(prix) && prix >= 0 ? 'PAYANTE' : 'A_PRECISER',
        prix:option.mode_tarification === 'PAYANTE' && Number.isFinite(prix) && prix >= 0 ? prix : null,
      };
    });
  return { club, adherent };
}

export function configurationPourRpc(configuration) {
  const nettoie = (row) => Object.fromEntries(Object.entries(row).filter(([key, value]) =>
    !['created_at','updated_at','produit_id','campagne_id','groupe','url'].includes(key) && value !== undefined
  ));
  return {
    visuels:(configuration.visuels || []).map(nettoie),
    groupes_tarifaires:(configuration.groupes_tarifaires || []).map(nettoie),
    options:(configuration.options || []).map(nettoie),
    marquages:(configuration.marquages || []).map(nettoie)
  };
}

export function configurationModele(configuration) {
  const faces = new Map((configuration.visuels || []).map((v) => [v.id, v.face]));
  return {
    groupes_tarifaires:(configuration.groupes_tarifaires || []).map(({ id, libelle, prix_ttc, ordre, actif }) => ({ id, libelle, prix_ttc, ordre, actif })),
    options:(configuration.options || []).map(({ id, type, libelle, obligatoire, actif, ordre, longueur_min, longueur_max, valeur_min, valeur_max, valeurs_autorisees, mode_tarification, prix_individuel_ttc, groupe_tarifaire_id }) => ({ id, type, libelle, obligatoire, actif, ordre, longueur_min, longueur_max, valeur_min, valeur_max, valeurs_autorisees, mode_tarification, prix_individuel_ttc, groupe_tarifaire_id })),
    marquages:(configuration.marquages || []).map(({ visuel_id, ...m }) => ({ ...m, face:faces.get(visuel_id) || 'AVANT' }))
  };
}

export function appliquerModele(configurationCible, modele) {
  const groupesMap = new Map();
  const optionsMap = new Map();
  const groupes = (modele.groupes_tarifaires || []).map((g) => { const id=uuidPersonnalisation(); groupesMap.set(g.id,id); return {...g,id}; });
  const options = (modele.options || []).map((o) => { const id=uuidPersonnalisation(); optionsMap.set(o.id,id); return {...o,id,groupe_tarifaire_id:o.groupe_tarifaire_id ? groupesMap.get(o.groupe_tarifaire_id) : null}; });
  const visuels = [...(configurationCible.visuels || [])];
  const parFace = new Map(visuels.map((v) => [v.face,v.id]));
  const marquages = (modele.marquages || []).map((m) => {
    const copie = { ...m };
    const face = copie.face;
    const option_id = copie.option_id;
    delete copie.face;
    delete copie.id;
    delete copie.option_id;
    let visuelId = parFace.get(face);
    if (!visuelId) { visuelId=uuidPersonnalisation(); parFace.set(face,visuelId); visuels.push({id:visuelId,face,libelle:null,storage_path:null,ordre:visuels.length,actif:true}); }
    return {...copie,id:uuidPersonnalisation(),visuel_id:visuelId,option_id:option_id ? optionsMap.get(option_id) : null};
  });
  return { visuels, groupes_tarifaires:groupes, options, marquages };
}
